"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactSelectPlus = _interopRequireDefault(require("react-select-plus"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _Dom = require("../utils/Dom");

var _Props = require("../utils/Props");

var _Functions = require("../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _OptionTypes = require("../types/OptionTypes");

var _PlacementConstants = require("../tooltip/PlacementConstants");

var _UITypeaheadResultsItem = _interopRequireDefault(require("../typeahead/results/UITypeaheadResultsItem"));

var _UILink = _interopRequireDefault(require("../link/UILink"));

var _UIControlledPopover = _interopRequireDefault(require("../tooltip/UIControlledPopover"));

var _UILoadingSpinner = _interopRequireDefault(require("../loading/UILoadingSpinner"));

var _UISearchInput = _interopRequireDefault(require("../input/UISearchInput"));

var _MultiSelectValue = _interopRequireDefault(require("./utils/MultiSelectValue"));

var _UISelectWithButtonAnchor = _interopRequireDefault(require("./internal/UISelectWithButtonAnchor"));

var _UISelectWithInputAnchor = _interopRequireDefault(require("./internal/UISelectWithInputAnchor"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var customRenderer = _interopRequireWildcard(require("../utils/propTypes/customRenderer"));

var _decorators = require("../utils/propTypes/decorators");

var _Tether = require("../constants/Tether");

var _UIButton = _interopRequireDefault(require("../button/UIButton"));

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _FieldsetContext = require("../context/FieldsetContext");

var Async = _reactSelectPlus.default.Async,
    Creatable = _reactSelectPlus.default.Creatable,
    stripDiacritics = _reactSelectPlus.default.stripDiacritics;
var SELECT_SIZE_OPTIONS = {
  default: '',
  small: 'private-form__selectplus--small'
};

var isVirtualized = function isVirtualized(menuRenderer) {
  return menuRenderer && menuRenderer.displayName === 'virtualizedMenuRenderer';
};

var LoadMoreComponent = function LoadMoreComponent(_ref) {
  var options = _ref.options,
      pagination = _ref.pagination;
  return _react.default.createElement("span", null, _react.default.createElement("span", {
    className: "private-form__selectplus--load-more-count"
  }, pagination.length ? _I18n.default.text('salesUI.UISelect.andMore', {
    count: pagination.length - options.length
  }) : ''), _react.default.createElement(_UILink.default, null, _I18n.default.text('salesUI.UISelect.loadMore')));
};

var multiDummyOption;

var getMultiDummyOption = function getMultiDummyOption() {
  multiDummyOption = multiDummyOption || {
    disabled: true,
    dropdownText: _I18n.default.text('salesUI.UISelect.allOptionsSelected'),
    isSpecial: true,
    title: '',
    value: '__MULTI_DUMMY_OPTION__'
  };
  return multiDummyOption;
};

var loadMoreOptionValue = '__LOAD_MORE_OPTION__';

var getLoadMoreOption = function getLoadMoreOption(_ref2) {
  var input = _ref2.input,
      loadMoreComponent = _ref2.loadMoreComponent,
      options = _ref2.options,
      pagination = _ref2.pagination;
  return {
    dropdownClassName: 'private-form__selectplus--load-more',
    dropdownText: customRenderer.render(loadMoreComponent, {
      options: options,
      pagination: pagination
    }),
    input: input,
    isSpecial: true,
    title: '',
    value: loadMoreOptionValue
  };
};

var getIsLoadingOption = function getIsLoadingOption() {
  return {
    disabled: true,
    dropdownClassName: 'private-dropdown__loading',
    dropdownText: _react.default.createElement(_UILoadingSpinner.default, {
      layout: "centered",
      size: "sm"
    }),
    isSpecial: true,
    title: '',
    value: '__IS_LOADING_OPTION__'
  };
};

var getInputProps = function getInputProps(autoComplete, disabled, id, searchable, computedAnchorType, handleAutosize, handlePaste, readOnly) {
  if (disabled || !searchable || computedAnchorType !== 'combined' || readOnly) return {};
  return {
    autoComplete: autoComplete,
    id: id,
    onAutosize: handleAutosize,
    onPaste: handlePaste
  };
};
/**
 * @param {Object} option The option to determine the checkbox state for
 * @param {*} value The `value` prop
 * @return {Object} { indeterminate, checked }
 */


var getCheckboxState = function getCheckboxState(option, value) {
  if (option.getCheckboxState) return option.getCheckboxState(option);
  var isOptionGroup = !!option.options;
  var isSelectAll = isOptionGroup && !!option.selectAll;
  var nestedOptionCount = 0;
  var selectedOptionCount = 0;

  if (isSelectAll) {
    var tabulate = function tabulate(o) {
      if (o.options) {
        o.options.forEach(tabulate);
      } else if (!o.disabled) {
        nestedOptionCount += 1;
        if (Array.isArray(value) && value.includes(o.value)) selectedOptionCount += 1;
      }
    };

    tabulate(option);
  }

  var indeterminate = isSelectAll && 0 < selectedOptionCount && selectedOptionCount < nestedOptionCount;
  var checked = isSelectAll ? nestedOptionCount === selectedOptionCount : !!(Array.isArray(value) && value.includes(option.value));
  return {
    indeterminate: indeterminate,
    checked: checked
  };
};

var makeNewOptionsCache = function makeNewOptionsCache(optionsCache, options) {
  var newOptionsCache = (0, _extends2.default)({}, optionsCache);

  var addOptionToCache = function addOptionToCache(option) {
    newOptionsCache[option.value] = option;
  };

  var addOptionListToCache = function addOptionListToCache(optionList) {
    optionList.forEach(function (option) {
      if (Array.isArray(option.options)) {
        addOptionListToCache(option.options);
      } else {
        addOptionToCache(option);
      }
    });
  }; // Recursively add all options, including those within groups, to the cache.


  addOptionListToCache(options);
  return newOptionsCache;
};

function promptTextCreator(label) {
  return _I18n.default.text('salesUI.UISelect.createOption', {
    label: _I18n.default.SafeString(label)
  });
}
/**
 * "Cleans" an input value. Matches the filter react-select-plus applies to the input passed to `loadOptionsProxy`. (#5289)
 */


function filterInputValue(inputValue, _ref3) {
  var _ref3$ignoreAccents = _ref3.ignoreAccents,
      ignoreAccents = _ref3$ignoreAccents === void 0 ? true : _ref3$ignoreAccents,
      _ref3$ignoreCase = _ref3.ignoreCase,
      ignoreCase = _ref3$ignoreCase === void 0 ? true : _ref3$ignoreCase;
  // https://github.com/HubSpot/react-select-plus/blob/8ae7465fc9b6b9600a01e4e23de97f2d403fd139/src/Async.js#L155-L163
  var transformedInputValue = inputValue;

  if (ignoreAccents) {
    transformedInputValue = stripDiacritics(transformedInputValue);
  }

  if (ignoreCase) {
    transformedInputValue = transformedInputValue.toLowerCase();
  }

  return transformedInputValue;
}

var UISelectCore =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UISelectCore, _Component);

  function UISelectCore() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UISelectCore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UISelectCore)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      controlWidth: 0,
      inputValue: '',
      isLoading: false,
      optionsCache: {},
      paginationCache: {},
      resetOption: null
    };
    _this.popoverRef = _react.default.createRef();

    _this.optionRendererProxy = function (option) {
      var _this$props = _this.props,
          optionRenderer = _this$props.optionRenderer,
          optionRendererIgnoresSpecialOptions = _this$props.optionRendererIgnoresSpecialOptions;

      if (optionRenderer == null || option.isSpecial && optionRendererIgnoresSpecialOptions) {
        return _this.defaultOptionRenderer(option);
      }

      return optionRenderer(option);
    };

    _this.defaultValueRenderer = function (option) {
      var _this$props2 = _this.props,
          itemComponent = _this$props2.itemComponent,
          valueComponent = _this$props2.valueComponent;
      return _react.default.createElement(_UITypeaheadResultsItem.default, {
        "aria-invalid": option.invalid,
        itemComponent: valueComponent || itemComponent,
        key: option.value,
        option: (0, _extends2.default)({}, option, {
          help: undefined
        }),
        _useButton: false,
        _useDropdownText: false
      });
    };

    _this.filterOptionsProxy = function (options, input, excludeOptions) {
      var _this$props3 = _this.props,
          anchorType = _this$props3.anchorType,
          clearable = _this$props3.clearable,
          filterOptions = _this$props3.filterOptions,
          ignoreAccents = _this$props3.ignoreAccents,
          ignoreCase = _this$props3.ignoreCase,
          isLoadingProp = _this$props3.isLoading,
          loadMoreComponent = _this$props3.loadMoreComponent,
          multi = _this$props3.multi,
          resetValue = _this$props3.resetValue,
          value = _this$props3.value;
      var _this$state = _this.state,
          isLoading = _this$state.isLoading,
          paginationCache = _this$state.paginationCache,
          resetOption = _this$state.resetOption;
      var filterOptionsFunc;

      if (filterOptions === false) {
        filterOptionsFunc = function filterOptionsFunc(x) {
          return x;
        };
      } else if (typeof filterOptions === 'function') {
        filterOptionsFunc = filterOptions;
      } else {
        filterOptionsFunc = _this.getDefaultFilterOptionsFunc();
      }

      var showSelectedOptions = _this.areOptionsToggleable({
        anchorType: anchorType,
        multi: multi
      });

      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }

      var filteredOptions = filterOptionsFunc.apply(void 0, [options, input, showSelectedOptions ? [] : excludeOptions].concat(rest));

      if (input.length === 0) {
        // Add multi dummy option, if needed (#1256)
        if (multi && options.length > 0 && filteredOptions.length === 0) {
          filteredOptions = filteredOptions.concat(getMultiDummyOption());
        } // Add resetOption, if needed (#2300)


        if (clearable && !multi && value != null && value !== resetValue) {
          filteredOptions = [resetOption].concat(filteredOptions);
        }
      }

      if (isLoading || isLoadingProp) {
        // Add "Loading..." option, if needed
        filteredOptions = filteredOptions.concat(getIsLoadingOption());
      } else {
        var paginationCacheKey = filterInputValue(input, {
          ignoreAccents: ignoreAccents,
          ignoreCase: ignoreCase
        });
        var pagination = paginationCache[paginationCacheKey]; // Add "Load more" option, if needed (#2031)

        if (pagination && pagination.hasMore) {
          filteredOptions = filteredOptions.concat(getLoadMoreOption({
            input: input,
            isLoading: isLoading,
            loadMoreComponent: loadMoreComponent,
            options: options,
            pagination: pagination
          }));
        }
      }

      return filteredOptions;
    };

    _this.creatableOnInputChangeProxy = function (str) {
      var internalCreatableSelect = _this.getInternalCreatableSelect();

      var newInputValue = _this.handleInputChange(str);

      internalCreatableSelect.inputValue = newInputValue;
      return newInputValue;
    };

    _this.handleChange = function (option) {
      // react-select-plus gives us an option object or null, which we pass to
      // onSelectedOptionChange, but our onChange handler expects just the new value.
      var _this$props4 = _this.props,
          onChange = _this$props4.onChange,
          onSelectedOptionChange = _this$props4.onSelectedOptionChange,
          value = _this$props4.value;
      (0, _Functions.callIfPossible)(onSelectedOptionChange, (0, _SyntheticEvent.default)(option));
      var newVal = null;

      if (Array.isArray(option)) {
        newVal = option.filter(Boolean).map(function (o) {
          return o.value;
        });
      } else if (option) {
        newVal = option.value;
      }

      if (newVal !== value) {
        onChange((0, _SyntheticEvent.default)(newVal));
      }
    };

    _this.handleInputKeyDown = function (evt) {
      var _this$props5 = _this.props,
          anchorType = _this$props5.anchorType,
          multi = _this$props5.multi,
          onInputKeyDown = _this$props5.onInputKeyDown,
          value = _this$props5.value;
      var key = evt.key;
      (0, _Functions.callIfPossible)(onInputKeyDown, evt);

      if (evt.defaultPrevented) {
        return;
      } // In multi-mode, we need to handle ENTER to allow the focused option to be toggled.


      if (key === 'Enter' && multi && _this.getAnchorType({
        anchorType: anchorType,
        multi: multi
      }) !== 'combined') {
        var internalSelect = _this.getInternalSelect();

        if (!internalSelect) {
          return;
        }

        var focusedOption = internalSelect._focusedOption;

        if (!focusedOption) {
          return;
        }

        if (focusedOption.value === loadMoreOptionValue) {
          _this.triggerLoadMore();

          return;
        }

        if (focusedOption.isSpecial || focusedOption.clearableValue === false) {
          return;
        }

        var valueToToggle = focusedOption.value;
        var willBeSelected = value.indexOf(valueToToggle) === -1;

        _this.toggleMultiValue(valueToToggle, willBeSelected);

        evt.preventDefault();
      }
    };

    _this.handleOptionToggle = function (option, evt) {
      var value = _this.props.value;

      if (option.options && option.selectAll) {
        var _getCheckboxState = getCheckboxState(option, value),
            checked = _getCheckboxState.checked,
            indeterminate = _getCheckboxState.indeterminate;

        _this.toggleGroup(option, !checked && !indeterminate);
      } else {
        var valueToToggle = option.value;

        _this.toggleMultiValue(valueToToggle, evt.target.checked);
      }
    };

    _this.handleClose = function (evt) {
      var _this$props6 = _this.props,
          onClose = _this$props6.onClose,
          onOpenChange = _this$props6.onOpenChange; // eslint-disable-line react/prop-types

      onOpenChange((0, _SyntheticEvent.default)(false));
      (0, _Functions.callIfPossible)(onClose, evt);
    };

    _this.handleOpen = function (evt) {
      var _this$props7 = _this.props,
          onOpen = _this$props7.onOpen,
          onOpenChange = _this$props7.onOpenChange; // eslint-disable-line react/prop-types

      onOpenChange((0, _SyntheticEvent.default)(true));
      (0, _Functions.callIfPossible)(onOpen, evt);
    };

    _this.triggerOpen = function () {
      var onOpenChange = _this.props.onOpenChange;
      onOpenChange((0, _SyntheticEvent.default)(true));
    };

    _this.handleInputChange = function (str) {
      var _this$props8 = _this.props,
          loadOptions = _this$props8.loadOptions,
          multi = _this$props8.multi,
          onInputChange = _this$props8.onInputChange;
      (0, _Functions.callIfPossible)(onInputChange, str);

      _this.setState({
        inputValue: str
      }); // Handle typing multi values separated by splitRegex.


      if (multi) {
        var splitValues = _this.getSplitValuesFromString(str, false);

        if (splitValues.length > 0) {
          _this.addMultiValues(splitValues);

          return '';
        }
      } // If the user typed a request that will hit the cache, ignore any pending request.


      if (loadOptions != null) {
        var internalAsyncSelect = _this.getInternalAsyncSelect();

        if (internalAsyncSelect != null) {
          if (internalAsyncSelect._cache && internalAsyncSelect._cache.hasOwnProperty(str)) {
            internalAsyncSelect._callback = null;

            _this.setState({
              isLoading: false
            });
          }
        }
      }

      return str;
    };

    _this.handleInputValueChange = function (evt) {
      var onInputValueChange = _this.props.onInputValueChange;
      (0, _Functions.callIfPossible)(onInputValueChange, evt);

      _this.resetPaginationCache();

      _this.setState({
        inputValue: evt.target.value
      });
    };

    _this.handlePaste = function (evt) {
      var _this$props9 = _this.props,
          multi = _this$props9.multi,
          onPaste = _this$props9.onPaste; // Allow developers to override default paste handling.

      (0, _Functions.callIfPossible)(onPaste, evt);

      if (evt.defaultPrevented) {
        return;
      }

      if (!multi) return;
      var clipboardData = evt.clipboardData || window.clipboardData;
      var pastedText = clipboardData.getData('Text');

      var splitValues = _this.getSplitValuesFromString(pastedText, true);

      if (splitValues.length > 0) {
        evt.preventDefault();

        _this.addMultiValues(splitValues);
      }
    };

    _this.focus = function () {
      try {
        _this._anchorRef.focus();
      } catch (e) {
        /* ¯\_(ツ)_/¯ */
      }
    };

    _this.handleAutosize = function () {
      if (_this.popoverRef.current) _this.popoverRef.current.reposition();
    };

    _this.dropdownContentRefCallback = function (dropdownEl) {
      if (dropdownEl) {
        dropdownEl.addEventListener('mousedown', _this.handleMouseDownOnDropdown);
      }
    };

    _this.anchorRefCallback = function (anchorRef) {
      var _this$state2 = _this.state,
          controlWidth = _this$state2.controlWidth,
          target = _this$state2.target;
      _this._anchorRef = anchorRef;
      var newTarget = (0, _reactDom.findDOMNode)(_this._anchorRef);

      var newControlWidth = _this.computeControlWidth(newTarget);

      if (target !== newTarget || controlWidth !== newControlWidth) {
        _this.setState({
          controlWidth: newControlWidth,
          target: newTarget
        });
      }
    };

    _this.selectRefCallback = function () {
      // Hackily override Select's selectValue and handleMouseDownOnMenu to support "Load more"
      var internalSelect = _this.getInternalSelect();

      if (!internalSelect) return;
      internalSelect.selectValue = _this.selectValueProxy.bind((0, _assertThisInitialized2.default)(_this), internalSelect.selectValue);

      var internalCreatableSelect = _this.getInternalCreatableSelect();

      if (!internalCreatableSelect) return;
      internalCreatableSelect.onInputChange = _this.creatableOnInputChangeProxy;
    };

    _this.getInternalSelect = function () {
      // Return our react-select Select instance, or null
      if (!_this._anchorRef) {
        return null;
      }

      if (_this._anchorRef.getInternalSelect) {
        return _this._anchorRef.getInternalSelect();
      }

      return _this._anchorRef.select || _this._anchorRef;
    };

    _this.getInternalCreatableSelect = function () {
      // Return our react-select Creatable instance, or null
      if (!_this._anchorRef) {
        return null;
      }

      if (_this._anchorRef.constructor === Creatable) {
        return _this._anchorRef;
      }

      return null;
    };

    _this.getInternalAsyncSelect = function () {
      // Return our react-select Async instance, or null
      if (!_this._anchorRef) {
        return null;
      }

      if (_this._anchorRef.getInternalAsyncSelect) {
        return _this._anchorRef.getInternalAsyncSelect();
      }

      if (_this._anchorRef.constructor === Async) {
        return _this._anchorRef;
      }

      return null;
    };

    _this.handleMouseDownOnDropdown = function (evt) {
      // react-select-plus normally closes the dropdown and blurs the input on mousedown. We need to
      // prevent that behavior for certain elements.
      var target = evt.target;

      if ((0, _Dom.closest)(target, '.private-dropdown__footer-container')) {
        evt.stopPropagation();
        evt.preventDefault();
        return;
      }

      if ((0, _Dom.closest)(target, '.private-form__selectplus--load-more')) {
        _this.triggerLoadMore();

        evt.stopPropagation();
        evt.preventDefault();
        return;
      }

      if ((0, _Dom.closest)(target, '.private-checkbox')) {
        evt.stopPropagation();
        evt.preventDefault();
        return;
      }
    };

    _this.loadOptionsProxy = function (input, loadOptionsCallback) {
      var _this$props10 = _this.props,
          open = _this$props10.open,
          loadOptions = _this$props10.loadOptions;

      if (input == null) {
        return;
      } // Show loading indicator until loadOptionsProxyCallback is called


      _this.setState({
        isLoading: true
      });

      _this._latestSearch = open ? input : null; // Special case: autoload search is designated as null
      // Keep a copy of all options returned by loadOptions

      var paginationCache = _this.state.paginationCache;

      var proxyCallback = _this.getLoadOptionsProxyCallback(open ? input : null, loadOptionsCallback);

      var result;

      try {
        result = loadOptions(input, proxyCallback, paginationCache[input || '']);
      } catch (error) {
        proxyCallback(error);
        setTimeout(function () {
          throw error;
        }, 0);
      }

      if (result && typeof result.then === 'function') {
        result.then(function (data) {
          proxyCallback(null, data || {});
        }, function (error) {
          proxyCallback(error);
          throw error;
        });
      }
    };

    _this.renderDropdown = function (props) {
      var _this$props11 = _this.props,
          closeOnTargetLeave = _this$props11.closeOnTargetLeave,
          onOpenChange = _this$props11.onOpenChange,
          open = _this$props11.open,
          placement = _this$props11.placement;
      return _react.default.createElement(_UIControlledPopover.default, {
        arrowSize: "none",
        autoPlacement: "vert",
        closeOnTargetLeave: closeOnTargetLeave,
        content: _this.renderDropdownContent(props),
        onOpenChange: onOpenChange,
        open: open,
        placement: placement || 'bottom right',
        popoverRef: _this.popoverRef,
        target: _this.state.target
      });
    };

    return _this;
  }

  (0, _createClass2.default)(UISelectCore, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.cacheOptions(this.props);
      this.generateResetOption(this.props);
      this._isMounted = true; // not strictly true, but componentDidMount() fires too late!

      this._getInputProps = (0, _memoizeOne.default)(getInputProps);
      this._initiallyOpen = this.props.open;
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.cacheOptions(nextProps);
      this.generateResetOption(nextProps);

      if (!this.props.open && nextProps.open) {
        this.resetPaginationCache();
      } else if (this.props.open && !nextProps.open) {
        this._initiallyOpen = false;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var controlEl = (0, _reactDom.findDOMNode)(this._anchorRef);

      if (!controlEl) {
        return;
      }

      var controlWidth = this.computeControlWidth(controlEl);

      if (controlWidth !== this.state.controlWidth) {
        this.setState({
          controlWidth: controlWidth
        });
      }

      if (!prevProps.open && this.props.open) {
        this.focus();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "cacheOptions",
    value: function cacheOptions(_ref4) {
      var options = _ref4.options;
      // Cache options provided via props (required for certain async scenarios, and for paste handling)
      var optionsCache = this.state.optionsCache;

      if (options) {
        var newOptionsCache = makeNewOptionsCache(optionsCache, options);
        this.setState({
          optionsCache: newOptionsCache
        });
      }
    }
  }, {
    key: "resetPaginationCache",
    value: function resetPaginationCache() {
      // If async caching is disabled, paginationCache should not persist across searches
      var cache = this.props.cache;

      if (cache === null || cache === false) {
        this.setState({
          paginationCache: {}
        });
      }
    }
  }, {
    key: "generateResetOption",
    value: function generateResetOption(_ref5) {
      var placeholder = _ref5.placeholder,
          resetValue = _ref5.resetValue;
      var resetOption = this.state.resetOption;
      var newResetOption = {
        buttonText: (0, _lazyEval.default)(placeholder),
        dropdownText: (0, _lazyEval.default)(placeholder),
        value: resetValue
      };

      if (!(resetOption && resetOption.buttonText === newResetOption.buttonText && resetOption.value === newResetOption.value)) {
        this.setState({
          resetOption: newResetOption
        });
      }
    }
  }, {
    key: "areOptionsToggleable",
    value: function areOptionsToggleable(_ref6) {
      var anchorType = _ref6.anchorType,
          multi = _ref6.multi;
      // Return true if we show options as checkboxes in the dropdown (#1976)
      var computedAnchorType = this.getAnchorType({
        anchorType: anchorType,
        multi: multi
      });
      return multi && computedAnchorType !== 'combined';
    }
  }, {
    key: "defaultOptionRenderer",
    value: function defaultOptionRenderer(option) {
      var _this$props12 = this.props,
          anchorType = _this$props12.anchorType,
          itemComponent = _this$props12.itemComponent,
          multi = _this$props12.multi,
          optionComponent = _this$props12.optionComponent,
          value = _this$props12.value;
      var isOptionGroup = !!option.options;
      var isSelectAll = isOptionGroup && !!option.selectAll;
      var toggleable = this.areOptionsToggleable({
        anchorType: anchorType,
        multi: multi
      }) && option.className !== 'Select-create-option-placeholder' && !option.isSpecial && !(isOptionGroup && !isSelectAll);

      var _getCheckboxState2 = getCheckboxState(option, value),
          indeterminate = _getCheckboxState2.indeterminate,
          checked = _getCheckboxState2.checked;

      return _react.default.createElement(_UITypeaheadResultsItem.default, {
        itemComponent: optionComponent || itemComponent,
        isIndeterminate: toggleable && indeterminate,
        isSelected: toggleable && checked,
        onToggle: this.handleOptionToggle.bind(this, option),
        option: option,
        style: option.dropdownStyle,
        toggleable: toggleable,
        _useButton: !toggleable
      });
    }
  }, {
    key: "getDefaultFilterOptionsFunc",
    // Extracted to a function so it can be stubbed out in tests
    value: function getDefaultFilterOptionsFunc() {
      return _reactSelectPlus.default.defaultProps.filterOptions;
    }
  }, {
    key: "selectValueProxy",
    value: function selectValueProxy(selectValue, selectedOption) {
      // If this is a "Load more" option, trigger load.
      if (selectedOption.value === loadMoreOptionValue) {
        this.triggerLoadMore();
      } // Prevent "special" options from being selected.


      if (selectedOption.isSpecial) {
        return;
      }

      selectValue(selectedOption);
    }
  }, {
    key: "triggerLoadMore",
    value: function triggerLoadMore() {
      // Trick Select.Async into calling loadOptions again, then move focus up one option
      var internalSelect = this.getInternalSelect();
      var internalAsyncSelect = this.getInternalAsyncSelect();

      if (!internalSelect || !internalAsyncSelect || !internalAsyncSelect.loadOptions) {
        return;
      }

      var _this$props13 = this.props,
          ignoreAccents = _this$props13.ignoreAccents,
          ignoreCase = _this$props13.ignoreCase;
      var visibleOptions = internalSelect._visibleOptions;
      var loadMoreOption = visibleOptions[visibleOptions.length - 1];
      var transformedInputValue = filterInputValue(loadMoreOption.input, {
        ignoreAccents: ignoreAccents,
        ignoreCase: ignoreCase
      });

      if (internalAsyncSelect._cache) {
        delete internalAsyncSelect._cache[transformedInputValue];
      }

      internalAsyncSelect.loadOptions(transformedInputValue);
      var normalOptions = internalSelect.props.options;
      internalSelect.setState({
        focusedOption: normalOptions[normalOptions.length - 1]
      });
    }
  }, {
    key: "toggleGroup",
    value: function toggleGroup(groupToToggle, willBeSelected) {
      var value = this.props.value;
      var valueCopy = (value || []).slice(0);
      var newValue = valueCopy;

      if (willBeSelected) {
        var addOptionValue = function addOptionValue(o) {
          if (o.options) {
            o.options.filter(function (option) {
              return !option.disabled;
            }).forEach(addOptionValue);
          } else {
            if (newValue.indexOf(o.value) === -1) newValue.push(o.value);
          }
        };

        addOptionValue(groupToToggle);
      } else {
        var removeOptionValue = function removeOptionValue(o) {
          if (o.options) {
            o.options.filter(function (option) {
              return !option.disabled;
            }).forEach(removeOptionValue);
          } else {
            newValue = newValue.filter(function (v) {
              return v !== o.value;
            });
          }
        };

        removeOptionValue(groupToToggle);
      }

      this.setMultiValues(newValue);
    }
  }, {
    key: "toggleMultiValue",
    value: function toggleMultiValue(valueToToggle, willBeSelected) {
      var value = this.props.value;
      var valueCopy = (value || []).slice(0);
      var newValue = null;

      if (willBeSelected) {
        newValue = valueCopy.concat(valueToToggle);
      } else {
        newValue = valueCopy.filter(function (v) {
          return v !== valueToToggle;
        });
      }

      this.setMultiValues(newValue);
    }
  }, {
    key: "addMultiValues",
    value: function addMultiValues(addValues) {
      var value = this.props.value;
      var newValues = (value || []).slice(0);
      addValues.forEach(function (v) {
        if (newValues.indexOf(v) === -1 && v !== '') newValues.push(v);
      });
      this.setMultiValues(newValues);
    }
  }, {
    key: "setMultiValues",
    value: function setMultiValues(newValues) {
      var optionsCache = this.state.optionsCache; // Map values to options

      var newOptions = newValues.map(function (v) {
        return optionsCache[v] || {
          text: v,
          value: v
        };
      });
      this.handleChange(newOptions);
    }
  }, {
    key: "getSplitValuesFromString",
    value: function getSplitValuesFromString(str, includeLastValue) {
      var _this$props14 = this.props,
          allowCreate = _this$props14.allowCreate,
          splitRegex = _this$props14.splitRegex;
      var strParts = str.split(splitRegex).map(function (s) {
        return s.trim();
      });

      if (!includeLastValue) {
        strParts = strParts.slice(0, strParts.length - 1);
      }

      if (strParts.length === 0) return []; // Create a map of option labels to options

      var optionsCache = this.state.optionsCache;
      var reverseOptionsCache = {};
      Object.keys(optionsCache).forEach(function (key) {
        var option = optionsCache[key];
        reverseOptionsCache[option.text || key] = option.value;
      }); // For each piece, see if it maps to an option label. If so, add that option's value to
      // the result. Otherwise, if allowCreate is enabled, add a new option.

      var result = [];
      strParts.forEach(function (label) {
        if (reverseOptionsCache.hasOwnProperty(label)) {
          result.push(reverseOptionsCache[label]);
        } else if (allowCreate && result.indexOf(label) === -1) {
          result.push(label);
        }
      });
      return result;
    }
  }, {
    key: "getMenuWidth",
    value: function getMenuWidth() {
      var menuWidth = this.props.menuWidth;

      if (menuWidth === 'auto') {
        return '';
      }

      if (typeof menuWidth === 'number') {
        return menuWidth;
      }

      return Math.max(this.state.controlWidth, _Tether.MIN_MENU_WIDTH);
    }
  }, {
    key: "computeControlWidth",
    value: function computeControlWidth(controlEl) {
      var open = this.props.open;

      if (!controlEl || !open) {
        return 0;
      }

      var exactWidth = controlEl.getBoundingClientRect().width;
      var roundedWidth = window.chrome ? Math.floor(exactWidth) : exactWidth;
      return roundedWidth - 2; // account for 1px border added by UIPopover
    }
  }, {
    key: "getLoadOptionsProxyCallback",
    value: function getLoadOptionsProxyCallback(input, loadOptionsCallback) {
      var _this2 = this;

      var proxyCallback = function proxyCallback(error, data) {
        if (!_this2._isMounted) return;
        var _this2$state = _this2.state,
            optionsCache = _this2$state.optionsCache,
            paginationCache = _this2$state.paginationCache;
        var newOptionsCache = optionsCache;
        var newPaginationCache = paginationCache; // Cache options so that we can render the selected value properly

        if (data && data.options) {
          newOptionsCache = makeNewOptionsCache(optionsCache, data.options);

          if (data.pagination) {
            newPaginationCache = (0, _extends2.default)({}, paginationCache);
            newPaginationCache[input || ''] = data.pagination;
          }
        }

        var internalAsyncSelect = _this2.getInternalAsyncSelect();

        _this2.setState({
          isLoading: internalAsyncSelect && internalAsyncSelect._callback != null && _this2._latestSearch !== input,
          optionsCache: newOptionsCache,
          paginationCache: newPaginationCache
        });

        for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
          rest[_key3 - 2] = arguments[_key3];
        }

        loadOptionsCallback.apply(void 0, [error, data].concat(rest));
      };

      return proxyCallback;
    }
  }, {
    key: "getValueAsObject",
    value: function getValueAsObject(value) {
      // In async mode, react-select needs the current value's object form to render it
      var optionsCache = this.state.optionsCache;

      if (!optionsCache) {
        return value;
      }

      if (Array.isArray(value)) {
        return value.map(function (v) {
          return optionsCache.hasOwnProperty(v) ? optionsCache[v] : v;
        });
      }

      return optionsCache.hasOwnProperty(value) ? optionsCache[value] : value;
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed(_ref7) {
      var multi = _ref7.multi,
          multiCollapseLimit = _ref7.multiCollapseLimit,
          open = _ref7.open,
          value = _ref7.value;
      return multiCollapseLimit != null && value != null && value.length > multiCollapseLimit && multi && !open;
    }
  }, {
    key: "getAnchorType",
    value: function getAnchorType(_ref8) {
      var anchorType = _ref8.anchorType,
          multi = _ref8.multi;

      if (anchorType === 'auto') {
        return multi ? 'combined' : 'button';
      }

      return anchorType;
    }
  }, {
    key: "getNoResultsText",
    value: function getNoResultsText(_ref9) {
      var noResultsText = _ref9.noResultsText;
      if (noResultsText != null) return (0, _lazyEval.default)(noResultsText);
      var inputValue = this.state.inputValue;
      return inputValue ? _I18n.default.text('salesUI.UISelect.noResults') : _I18n.default.text('salesUI.UISelect.typeToSearch');
    }
  }, {
    key: "getMenuRenderer",
    value: function getMenuRenderer(_ref10) {
      var itemComponent = _ref10.itemComponent,
          menuRenderer = _ref10.menuRenderer,
          menuWidth = _ref10.menuWidth,
          optionRenderer = _ref10.optionRenderer;

      if (isVirtualized(menuRenderer)) {
        if (optionRenderer || itemComponent !== UISelectCore.defaultProps.itemComponent) {
          _devLogger.default.warn({
            message: 'UISelect: virtualize cannot be used with optionRenderer or itemComponent',
            key: 'UISelect: virtualizeCustomRenderer'
          });

          return undefined;
        }

        if (menuWidth === 'auto') {
          _devLogger.default.warn({
            message: 'UISelect: virtualize canot be used with menuWidth="auto"',
            key: 'UISelect: virtualizeAutoWidth'
          });

          return undefined;
        }

        return menuRenderer(this.getMenuWidth());
      }

      return menuRenderer;
    }
  }, {
    key: "renderDropdownContent",
    value: function renderDropdownContent(props) {
      var _this$props15 = this.props,
          dropdownClassName = _this$props15.dropdownClassName,
          menuRenderer = _this$props15.menuRenderer,
          resultsClassName = _this$props15.resultsClassName;
      var className = (0, _classnames.default)(dropdownClassName, 'private-dropdown__results', {
        'private-dropdown--virtualized': isVirtualized(menuRenderer)
      });
      return _react.default.createElement("span", {
        className: (0, _classnames.default)('private-typeahead-results', resultsClassName),
        "data-dropdown-results": true
      }, _react.default.createElement("div", {
        className: className,
        ref: this.dropdownContentRefCallback,
        style: {
          width: this.getMenuWidth()
        }
      }, props.children, this.renderDropdownFooter()));
    }
  }, {
    key: "renderDropdownFooter",
    value: function renderDropdownFooter() {
      var dropdownFooter = this.props.dropdownFooter;

      if (!dropdownFooter) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "private-dropdown__footer-container"
      }, dropdownFooter);
    }
  }, {
    key: "renderCollapsedAnchor",
    value: function renderCollapsedAnchor(combinedAnchorClassName, multiCollapseLimit, value, valueRenderer, rest) {
      var _this3 = this;

      var optionsCache = this.state.optionsCache;
      var renderedValues = value.slice(0, multiCollapseLimit).map(function (v) {
        var option = optionsCache[v] || {
          text: v,
          value: v
        };

        var valueNode = (valueRenderer || _this3.defaultValueRenderer)(option);

        return _react.default.createElement(_MultiSelectValue.default, {
          key: v,
          closeable: false,
          disabled: option.disabled,
          value: option
        }, valueNode);
      });
      var hiddenValueCount = value.length - renderedValues.length;
      var andMoreNode = hiddenValueCount > 0 ? _react.default.createElement(_UIButton.default, {
        "data-hidden-value-count": hiddenValueCount,
        use: "transparent"
      }, _I18n.default.text('salesUI.UISelect.plusMore', {
        count: hiddenValueCount
      })) : null; // We use the same classnames as react-select here, to get the same appearance.

      return _react.default.createElement(_UIClickable.default, (0, _extends2.default)({}, (0, _Props.getAriaAndDataProps)(rest), {
        className: (0, _classnames.default)('Select Select--multi', combinedAnchorClassName),
        "data-collapsed": true,
        onClick: this.triggerOpen,
        onFocus: this.triggerOpen
      }), _react.default.createElement("div", {
        className: "Select-control"
      }, _react.default.createElement("div", {
        className: "Select-multi-value-wrapper"
      }, renderedValues, andMoreNode), _react.default.createElement("div", {
        className: "Select-arrow-zone"
      }, _react.default.createElement("div", {
        className: "Select-arrow"
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props16 = this.props,
          allowCreate = _this$props16.allowCreate,
          anchorType = _this$props16.anchorType,
          autoComplete = _this$props16.autoComplete,
          autoFocus = _this$props16.autoFocus,
          ButtonContent = _this$props16.ButtonContent,
          buttonSize = _this$props16.buttonSize,
          buttonUse = _this$props16.buttonUse,
          className = _this$props16.className,
          clearable = _this$props16.clearable,
          closeOnTargetLeave = _this$props16.closeOnTargetLeave,
          disabled = _this$props16.disabled,
          error = _this$props16.error,
          id = _this$props16.id,
          ignoreAccents = _this$props16.ignoreAccents,
          ignoreCase = _this$props16.ignoreCase,
          inputRef = _this$props16.inputRef,
          inputValue = _this$props16.inputValue,
          isLoading = _this$props16.isLoading,
          itemComponent = _this$props16.itemComponent,
          loadOptions = _this$props16.loadOptions,
          menuRenderer = _this$props16.menuRenderer,
          menuWidth = _this$props16.menuWidth,
          multi = _this$props16.multi,
          multiCollapseLimit = _this$props16.multiCollapseLimit,
          noResultsText = _this$props16.noResultsText,
          __onChange = _this$props16.onChange,
          __onInputValueChange = _this$props16.onInputValueChange,
          onOpenChange = _this$props16.onOpenChange,
          __onSelectedOptionChange = _this$props16.onSelectedOptionChange,
          open = _this$props16.open,
          __optionComponent = _this$props16.optionComponent,
          optionRenderer = _this$props16.optionRenderer,
          options = _this$props16.options,
          placeholder = _this$props16.placeholder,
          readOnly = _this$props16.readOnly,
          resetValue = _this$props16.resetValue,
          searchable = _this$props16.searchable,
          searchClassName = _this$props16.searchClassName,
          searchPlaceholder = _this$props16.searchPlaceholder,
          searchPromptText = _this$props16.searchPromptText,
          __splitRegex = _this$props16.splitRegex,
          tabIndex = _this$props16.tabIndex,
          value = _this$props16.value,
          __valueComponent = _this$props16.valueComponent,
          valueRenderer = _this$props16.valueRenderer,
          rest = (0, _objectWithoutProperties2.default)(_this$props16, ["allowCreate", "anchorType", "autoComplete", "autoFocus", "ButtonContent", "buttonSize", "buttonUse", "className", "clearable", "closeOnTargetLeave", "disabled", "error", "id", "ignoreAccents", "ignoreCase", "inputRef", "inputValue", "isLoading", "itemComponent", "loadOptions", "menuRenderer", "menuWidth", "multi", "multiCollapseLimit", "noResultsText", "onChange", "onInputValueChange", "onOpenChange", "onSelectedOptionChange", "open", "optionComponent", "optionRenderer", "options", "placeholder", "readOnly", "resetValue", "searchable", "searchClassName", "searchPlaceholder", "searchPromptText", "splitRegex", "tabIndex", "value", "valueComponent", "valueRenderer"]);
      var resetOption = this.state.resetOption;
      var combinedAnchorClassName = (0, _classnames.default)(className, 'private-form__selectplus', {
        'private-form__selectplus--multi': multi,
        'private-form__control--error': error,
        // follow convention of disabled className
        'is-readonly': readOnly
      }); // Use an HOC around React Select, if applicable

      var SelectComponent = _reactSelectPlus.default;

      if (loadOptions) {
        SelectComponent = _reactSelectPlus.default.Async;
      } else if (allowCreate) {
        SelectComponent = _reactSelectPlus.default.Creatable;
      } // Use the virtualizedMenuRenderer, if it's provided and compatible with the other props


      var computedMenuRenderer = this.getMenuRenderer({
        itemComponent: itemComponent,
        menuRenderer: menuRenderer,
        menuWidth: menuWidth,
        optionRenderer: optionRenderer
      }); // Determine what type of control the dropdown is attached to

      var computedAnchorType = this.getAnchorType({
        anchorType: anchorType,
        multi: multi
      }); // A null or undefined value should be considered equivalent to resetValue

      var computedValue = value == null ? resetValue : value;

      if (loadOptions && allowCreate) {
        _devLogger.default.warn({
          message: 'UISelect: loadOptions and allowCreate are mutually exclusive.',
          key: 'UISelect: asyncCreatable'
        });
      }

      if (rest.autofocus) {
        _devLogger.default.warn({
          message: "UISelect: The autofocus prop is deprecated in favor of autoFocus to match React's autoFocus prop",
          key: 'UISelect: autofocus'
        });
      }

      if (inputRef && computedAnchorType === 'combined') {
        _devLogger.default.warn({
          message: 'UISelect: The inputRef prop is only supported with anchorType="input" or anchorType="button"',
          key: 'UISelect: inputRef'
        });
      } // We need to attach two ref callbacks to the combined anchor.


      this._refSequence = this._refSequence || (0, _Functions.sequence)(this.anchorRefCallback, this.selectRefCallback); // Bootstrap a read-only state on the "external" Select component by disabling interactivity
      // Only needed for the "combined" anchorType - readOnly class prevents disabled styles from being applied

      var readOnlyProps = readOnly ? {
        disabled: true
      } : {};
      return _react.default.createElement(_FieldsetContext.Consumer, null, function (_ref11) {
        var fieldDisabled = _ref11.disabled,
            fieldSize = _ref11.size;
        var computedDisabled = disabled || fieldDisabled; // Props that are used regardless of anchor type

        var commonProps = (0, _extends2.default)({}, rest, {
          backspaceRemoves: multi && computedAnchorType === 'combined',
          clearable: computedAnchorType === 'combined' ? clearable : false,
          disabled: computedDisabled,
          filterOptions: _this4.filterOptionsProxy,
          id: id,
          ignoreAccents: ignoreAccents,
          ignoreCase: ignoreCase,
          inputProps: _this4._getInputProps(autoComplete, computedDisabled, id, searchable, computedAnchorType, _this4.handleAutosize, _this4.handlePaste, readOnly),
          isLoading: isLoading != null ? isLoading : _this4.state.isLoading,
          isOpen: open && !readOnly && !!_this4.state.target,
          labelKey: 'text',
          loadOptions: loadOptions ? _this4.loadOptionsProxy : undefined,
          loadingPlaceholder: null,
          menuRenderer: computedMenuRenderer,
          multi: multi,
          noResultsText: _this4.getNoResultsText({
            noResultsText: noResultsText
          }),
          onChange: _this4.handleChange,
          onClose: _this4.handleClose,
          onInputChange: _this4.handleInputChange,
          onInputKeyDown: _this4.handleInputKeyDown,
          onOpen: _this4.handleOpen,
          onPaste: _this4.handlePaste,
          openAfterFocus: true,
          optionRenderer: _this4.optionRendererProxy,
          options: loadOptions ? undefined : options,
          placeholder: (0, _lazyEval.default)(placeholder),
          readOnly: readOnly,
          ref: _this4.anchorRefCallback,
          renderInvalidValues: true,
          required: false,
          resetValue: resetValue,
          searchable: searchable,
          searchPromptText: (0, _lazyEval.default)(searchPromptText),
          tabIndex: tabIndex,
          tabSelectsValue: false,
          value: loadOptions ? _this4.getValueAsObject(computedValue) : computedValue,
          valueComponent: multi ? _MultiSelectValue.default : _reactSelectPlus.default.defaultProps.valueComponent,
          valueRenderer: valueRenderer || _this4.defaultValueRenderer
        });
        var simpleAnchorClassName = (0, _classnames.default)(className, SELECT_SIZE_OPTIONS[fieldSize], {
          'private-form__control--error': error
        });

        if (computedAnchorType === 'input') {
          return _react.default.createElement(_UISelectWithInputAnchor.default, (0, _extends2.default)({}, commonProps, {
            autoComplete: autoComplete,
            autoFocus: autoFocus,
            className: simpleAnchorClassName,
            dropdownComponent: _this4.renderDropdown,
            error: error,
            inputRef: inputRef,
            inputValue: inputValue,
            onInputValueChange: _this4.handleInputValueChange,
            onOpenChange: onOpenChange,
            selectComponent: SelectComponent,
            selectRef: _this4.selectRefCallback
          }));
        }

        if (_this4.isCollapsed({
          multi: multi,
          multiCollapseLimit: multiCollapseLimit,
          open: open,
          value: value
        })) {
          return _this4.renderCollapsedAnchor(combinedAnchorClassName, multiCollapseLimit, value, valueRenderer, rest);
        }

        if (computedAnchorType === 'button') {
          return _react.default.createElement(_UISelectWithButtonAnchor.default, (0, _extends2.default)({}, commonProps, {
            autoComplete: autoComplete,
            autoFocus: autoFocus,
            buttonSize: buttonSize,
            ButtonContent: ButtonContent,
            buttonUse: buttonUse,
            className: simpleAnchorClassName,
            closeOnTargetLeave: closeOnTargetLeave,
            dropdownContentRef: _this4.dropdownContentRefCallback,
            dropdownFooter: _this4.renderDropdownFooter(),
            error: error,
            initiallyOpen: _this4._initiallyOpen,
            inputRef: inputRef,
            menuWidth: menuWidth,
            onInputValueChange: _this4.handleInputValueChange,
            onOpenChange: onOpenChange,
            resetOption: resetOption,
            searchClassName: searchClassName,
            searchPlaceholder: (0, _lazyEval.default)(searchPlaceholder),
            selectComponent: SelectComponent,
            selectRef: _this4.selectRefCallback
          }));
        }

        return _react.default.createElement(SelectComponent, (0, _extends2.default)({
          autofocus: autoFocus
        }, commonProps, {
          className: combinedAnchorClassName,
          dropdownComponent: _this4.renderDropdown,
          ref: _this4._refSequence,
          tabIndex: typeof tabIndex === 'number' ? String(tabIndex) : tabIndex
        }, readOnlyProps));
      });
    }
  }]);
  return UISelectCore;
}(_react.Component);

UISelectCore.propTypes = {
  allowCreate: _propTypes.default.bool,
  anchorType: _propTypes.default.oneOf(['auto', 'button', 'combined', 'input']),
  autoComplete: _propTypes.default.string,
  autoFocus: _propTypes.default.bool,
  autoload: _propTypes.default.bool,
  ButtonContent: _UISelectWithButtonAnchor.default.propTypes.ButtonContent,
  buttonSize: _UIButton.default.propTypes.size,
  buttonUse: _UIButton.default.propTypes.use,
  cache: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.bool]),
  clearable: _propTypes.default.bool.isRequired,
  closeOnTargetLeave: _propTypes.default.bool,
  delimiter: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool,
  dropdownClassName: _propTypes.default.string,
  dropdownFooter: _propTypes.default.node,
  error: _propTypes.default.bool,
  filterOptions: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool]),
  id: _propTypes.default.string,
  ignoreAccents: (0, _decorators.hidden)(_propTypes.default.bool),
  ignoreCase: (0, _decorators.hidden)(_propTypes.default.bool),
  inputComponent: _propTypes.default.func,
  inputRef: _refObject.default,
  inputValue: _propTypes.default.string,
  isLoading: _propTypes.default.bool,
  itemComponent: _propTypes.default.elementType,
  loadMoreComponent: customRenderer.propType,
  loadOptions: _propTypes.default.func,
  menuRenderer: _propTypes.default.func,
  menuWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),
  minimumSearchCount: _propTypes.default.number,
  multi: _propTypes.default.bool.isRequired,
  multiCollapseLimit: _propTypes.default.number,
  noResultsText: (0, _createLazyPropType.default)(_propTypes.default.node),
  onChange: _propTypes.default.func,
  onInputKeyDown: _propTypes.default.func,
  onInputChange: _propTypes.default.func,
  onInputValueChange: _propTypes.default.func,
  onOpenChange: _propTypes.default.func,
  onPaste: _propTypes.default.func,
  onSelectedOptionChange: _propTypes.default.func,
  open: _propTypes.default.bool,
  optionComponent: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_OptionTypes.OptionOrGroupType),
  optionRenderer: _propTypes.default.func,
  optionRendererIgnoresSpecialOptions: _propTypes.default.bool,
  placeholder: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
  placement: _propTypes.default.oneOf(_PlacementConstants.PLACEMENTS),
  promptTextCreator: _propTypes.default.func,
  readOnly: _propTypes.default.bool,
  resetValue: _OptionTypes.ValueType,
  resultsClassName: _propTypes.default.string,
  search: _propTypes.default.string,
  searchable: _propTypes.default.bool.isRequired,
  searchClassName: _propTypes.default.string,
  searchPlaceholder: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired,
  searchPromptText: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired,
  splitRegex: _propTypes.default.object,
  tabIndex: _propTypes.default.number,
  value: _OptionTypes.ValueType,
  valueComponent: _propTypes.default.elementType,
  valueRenderer: _propTypes.default.func,
  _forcePlaceholder: _propTypes.default.bool
};
UISelectCore.defaultProps = {
  allowCreate: false,
  anchorType: 'auto',
  autoComplete: 'off',
  autoload: true,
  buttonSize: 'default',
  buttonUse: 'form',
  clearable: false,
  delimiter: ';',
  open: false,
  ignoreAccents: true,
  ignoreCase: true,
  inputComponent: _UISearchInput.default,
  itemComponent: 'span',
  loadMoreComponent: LoadMoreComponent,
  minimumSearchCount: 8,
  multi: false,
  optionRendererIgnoresSpecialOptions: false,
  placeholder: function placeholder() {
    return _I18n.default.text('salesUI.UISelect.placeholder');
  },
  promptTextCreator: promptTextCreator,
  resetValue: '',
  searchable: true,
  searchPlaceholder: function searchPlaceholder() {
    return _I18n.default.text('salesUI.UISearchableSelectInput.placeholder');
  },
  searchPromptText: function searchPromptText() {
    return _I18n.default.text('salesUI.UISelect.typeToSearch');
  },
  splitRegex: /;/,
  value: '',
  _forcePlaceholder: false
};
UISelectCore.displayName = 'UISelect';
var UISelect = (0, _Controllable.default)(UISelectCore, ['open', 'value']);
UISelect.stripDiacritics = stripDiacritics;
var _default = UISelect;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/input/UISelect.js
// module id = 320
// module chunks = 5 6